import { object, string, boolean, AnySchema } from "yup";
import { TFunction } from "i18n";

export const MAX_MESSAGE_LENGTH = 3000;

export const MAX_EMAIL_LENGTH = 254;

export const MAX_NAME_LENGTH = 250;

export const MAX_CONTACT_NO_LENGTH = 30;

export const MAX_COMPANY_NAME_LENGTH = 75;

export const MAX_COMPANY_WEBSITE_LENGTH = 75;

type ValidationSchemaOverrides = Partial<{
  senderName: AnySchema;
  senderEmail: AnySchema;
  senderTelephoneNumber: AnySchema;
  companyName: AnySchema;
  companyWebsite: AnySchema;
  message: AnySchema;
}>;

export const validationSchema = (
  t: TFunction,
  overrides?: ValidationSchemaOverrides
) => {
  const yourName = t("common:label.yourName");
  const yourEmail = t("common:label.yourEmail");
  const emailValidation = t("common:contactPerformerModal.emailValidation");
  const yourMessage = t("common:contactPerformerModal.yourMessage");
  const yourContactNumberOptional = t(
    "common:contactPerformerModal.yourContactNumberOptional"
  );
  const companyName = t("common:contactPerformerModal.companyName");
  const companyWebsiteSocialMedia = t(
    "common:contactPerformerModal.companyWebsiteSocialMedia"
  );

  return object().shape({
    senderName: string()
      .max(
        MAX_NAME_LENGTH,
        t("common:validation.error.entryMaxLength", {
          fieldName: yourName,
          length: MAX_NAME_LENGTH,
        })
      )
      .required(
        t("common:validation.error.entryRequired", { fieldName: yourName })
      ),
    senderEmail: string()
      .email(emailValidation)
      .max(
        MAX_EMAIL_LENGTH,
        t("common:validation.error.entryMaxLength", {
          fieldName: yourEmail,
          length: MAX_EMAIL_LENGTH,
        })
      )
      .required(
        t("common:validation.error.entryRequired", { fieldName: yourEmail })
      ),
    senderTelephoneNumber: string()
      .nullable()
      .max(
        MAX_CONTACT_NO_LENGTH,
        t("common:validation.error.entryMaxLength", {
          fieldName: yourContactNumberOptional,
          length: MAX_CONTACT_NO_LENGTH,
        })
      ),
    companyName: string()
      .nullable()
      .max(
        MAX_COMPANY_NAME_LENGTH,
        t("common:validation.error.entryMaxLength", {
          fieldName: companyName,
          length: MAX_COMPANY_NAME_LENGTH,
        })
      ),
    companyWebsite: string()
      .nullable()
      .max(
        MAX_COMPANY_WEBSITE_LENGTH,
        t("common:validation.error.entryMaxLength", {
          fieldName: companyWebsiteSocialMedia,
          length: MAX_COMPANY_WEBSITE_LENGTH,
        })
      ),
    message: string()
      .max(
        MAX_MESSAGE_LENGTH,
        t("common:validation.error.entryMaxLength", {
          fieldName: yourMessage,
          length: MAX_MESSAGE_LENGTH,
        })
      )
      .required(
        t("common:validation.error.entryRequired", { fieldName: yourMessage })
      ),
    consent: boolean().isTrue(t("common:validation.please.select.one")),
    ...overrides,
  });
};
